export const CONSTRUCTION_PROCESS_OPTIONS = [
  { value: '101_REPLANTEOS', label: '101_REPLANTEOS' },
  {
    value: '102_REPOSICIÓN DE SERVICIOS AFECTADOS',
    label: '102_REPOSICIÓN DE SERVICIOS AFECTADOS',
  },
  {
    value: '103_DEMOLICIONES Y DERRIBOS',
    label: '103_DEMOLICIONES Y DERRIBOS',
  },
  {
    value: '104_OBTENCIÓN, ALMACÉN Y DESECHO DE MATERIALES',
    label: '104_OBTENCIÓN, ALMACÉN Y DESECHO DE MATERIALES',
  },
  {
    value: '105_MONTAJE DE INSTALACIONES AUXILIARES',
    label: '105_MONTAJE DE INSTALACIONES AUXILIARES',
  },
  {
    value: '106_LIMPIEZA Y MANTENIMIENTO DE OBRA Y ACCESOS',
    label: '106_LIMPIEZA Y MANTENIMIENTO DE OBRA Y ACCESOS',
  },
  {
    value: '107_EXPLOTACIÓN DE INSTALACIONES AUXILIARES',
    label: '107_EXPLOTACIÓN DE INSTALACIONES AUXILIARES',
  },
  {
    value: '201_VACIADOS, DESMONTES Y TERRAPLENES',
    label: '201_VACIADOS, DESMONTES Y TERRAPLENES',
  },
  {
    value: '202_EXCAVACIONES Y RELLENOS EN ZANJAS, CIMIENTOS Y POZOS',
    label: '202_EXCAVACIONES Y RELLENOS EN ZANJAS, CIMIENTOS Y POZOS',
  },
  {
    value: '203_DRAGADOS, EXCAVACIONES Y RELLENOS MARINOS',
    label: '203_DRAGADOS, EXCAVACIONES Y RELLENOS MARINOS',
  },
  {
    value: '204_PERFORACIÓN DE TÚNELES, GALERÍAS Y POZOS',
    label: '204_PERFORACIÓN DE TÚNELES, GALERÍAS Y POZOS',
  },
  {
    value: '205_CUERPO DE PRESA DE MATERIALES SUELTOS',
    label: '205_CUERPO DE PRESA DE MATERIALES SUELTOS',
  },
  {
    value: '301_TRATAMIENTO Y DRENAJE DE TERRENOS',
    label: '301_TRATAMIENTO Y DRENAJE DE TERRENOS',
  },
  {
    value: '302_SOSTENIMIENTO Y PROTECCIÓN DE TERRENOS',
    label: '302_SOSTENIMIENTO Y PROTECCIÓN DE TERRENOS',
  },
  {
    value: '303_TABLESTACADOS Y SIMILARES',
    label: '303_TABLESTACADOS Y SIMILARES',
  },
  {
    value: '304_ESCOLLERAS Y MUROS DE PIEDRA',
    label: '304_ESCOLLERAS Y MUROS DE PIEDRA',
  },
  {
    value: '305_MUROS DE TIERRA',
    label: '305_MUROS DE TIERRA',
  },
  {
    value: '306_MANTOS DE PROTECCIÓN CON ELEMENTOS PREFABRICADOS',
    label: '306_MANTOS DE PROTECCIÓN CON ELEMENTOS PREFABRICADOS',
  },
  {
    value: '401_CIMENTACIONES DE HORMIGÓN',
    label: '401_CIMENTACIONES DE HORMIGÓN',
  },
  {
    value: '402_ESTRUCTURAS Y OBRAS DE HORMIGÓN IN SITU',
    label: '402_ESTRUCTURAS Y OBRAS DE HORMIGÓN IN SITU',
  },
  {
    value: '403_ESTRUCTURAS Y OBRAS DE HORMIGÓN PREFABRICADO',
    label: '403_ESTRUCTURAS Y OBRAS DE HORMIGÓN PREFABRICADO',
  },
  {
    value: '404_ESTRUCTURAS DE ACERO',
    label: '404_ESTRUCTURAS DE ACERO',
  },
  {
    value: '405_ESTRUCTURAS DESMONTABLES Y PREFABRICADAS',
    label: '405_ESTRUCTURAS DESMONTABLES Y PREFABRICADAS',
  },
  {
    value: '406_MACIZOS DE HORMIGÓN',
    label: '406_MACIZOS DE HORMIGÓN',
  },
  {
    value: '407_MACIZOS DE HORMIGÓN COMPACTADO',
    label: '407_MACIZOS DE HORMIGÓN COMPACTADO',
  },
  {
    value: '408_OTRAS ESTRUCTURAS',
    label: '408_OTRAS ESTRUCTURAS',
  },
  {
    value: '501_FIRMES GRANULARES',
    label: '501_FIRMES GRANULARES',
  },
  {
    value: '502_FIRMES DE HORMIGÓN',
    label: '502_FIRMES DE HORMIGÓN',
  },
  {
    value: '503_FIRMES AGLOMERADOS CON CONGLOMERADO ASFÁLTICO',
    label: '503_FIRMES AGLOMERADOS CON CONGLOMERADO ASFÁLTICO',
  },
  {
    value: '504_FIRMES AGLOMERADOS CON CONGLOMERADO HIDRÁULICOS',
    label: '504_FIRMES AGLOMERADOS CON CONGLOMERADO HIDRÁULICOS',
  },
  {
    value: '505_FIRMES DE ADOQUINADO',
    label: '505_FIRMES DE ADOQUINADO',
  },
  {
    value: '506_PAVIMENTOS DE BALDOSAS',
    label: '506_PAVIMENTOS DE BALDOSAS',
  },
  {
    value: '507_ACERAS',
    label: '507_ACERAS',
  },
  {
    value: '508_PAVIMENTOS DE MADERA',
    label: '508_PAVIMENTOS DE MADERA',
  },
  {
    value: '509_BORDILLOS',
    label: '509_BORDILLOS',
  },
  {
    value: '601_FÁBRICAS DE LADRILLO',
    label: '601_FÁBRICAS DE LADRILLO',
  },
  {
    value: '602_FÁBRICAS DE BLOQUES LIGEROS DE HORMIGÓN',
    label: '602_FÁBRICAS DE BLOQUES LIGEROS DE HORMIGÓN',
  },
  {
    value: '603_FÁBRICAS DE BLOQUES DE HORMIGÓN',
    label: '603_FÁBRICAS DE BLOQUES DE HORMIGÓN',
  },
  {
    value: '604_OBRAS DE FÁBRICA MIXTAS Y DE PIEDRA',
    label: '604_OBRAS DE FÁBRICA MIXTAS Y DE PIEDRA',
  },
  {
    value: '605_MUROS CORTINA',
    label: '605_MUROS CORTINA',
  },
  {
    value: '606_PARTICIONES LIGERAS Y PREFABRICADAS',
    label: '606_PARTICIONES LIGERAS Y PREFABRICADAS',
  },
  {
    value: '701_DRENAJE DE VIALES Y OBRAS LINEALES',
    label: '701_DRENAJE DE VIALES Y OBRAS LINEALES',
  },
  {
    value: '702_DRENAJE Y SANEAMIENTO DE EDIFICIOS',
    label: '702_DRENAJE Y SANEAMIENTO DE EDIFICIOS',
  },
  {
    value: '703_DRENAJE DE TERRENOS',
    label: '703_DRENAJE DE TERRENOS',
  },
  {
    value: '704_REDES DE DISTRIBUCIÓN',
    label: '704_REDES DE DISTRIBUCIÓN',
  },
  {
    value: '705_OTROS SISTEMAS DE DISTRIBUCIÓN Y SANEAMIENTO',
    label: '705_OTROS SISTEMAS DE DISTRIBUCIÓN Y SANEAMIENTO',
  },
  {
    value: '801_CUBIERTAS Y AZOTEAS TRANSITABLES',
    label: '801_CUBIERTAS Y AZOTEAS TRANSITABLES',
  },
  {
    value: '802_CUBIERTAS INCLINADAS DE TEJAS DE ARCILLA',
    label: '802_CUBIERTAS INCLINADAS DE TEJAS DE ARCILLA',
  },
  {
    value: '803_CUBIERTAS DE PANELES Y CHAPAS DE HORMIGÓN',
    label: '803_CUBIERTAS DE PANELES Y CHAPAS DE HORMIGÓN',
  },
  {
    value: '804_CUBIERTAS DE CHAPAS METÁLICAS',
    label: '804_CUBIERTAS DE CHAPAS METÁLICAS',
  },
  {
    value: '805_CUBIERTAS DE PLACAS Y PLANCHAS DE AMIANTO-CEMENTO',
    label: '805_CUBIERTAS DE PLACAS Y PLANCHAS DE AMIANTO-CEMENTO',
  },
  {
    value: '806_CUBIERTAS DE PLACAS DE MATERIALES PLÁSTICOS',
    label: '806_CUBIERTAS DE PLACAS DE MATERIALES PLÁSTICOS',
  },
  {
    value: '807_CUBIERTAS DE PLACAS LIGERAS COMPUESTAS',
    label: '807_CUBIERTAS DE PLACAS LIGERAS COMPUESTAS',
  },
  {
    value: '808_CUBIERTAS DE ELEMENTOS DE MADERA',
    label: '808_CUBIERTAS DE ELEMENTOS DE MADERA',
  },
  {
    value: '809_CUBIERTAS DE VIDRIO',
    label: '809_CUBIERTAS DE VIDRIO',
  },
  {
    value: '901_SOLADOS HIDRÁULICOS, DE ARCILLA Y PIEDRA NATURAL',
    label: '901_SOLADOS HIDRÁULICOS, DE ARCILLA Y PIEDRA NATURAL',
  },
  {
    value: '902_PAVIMENTOS FLEXIBLES',
    label: '902_PAVIMENTOS FLEXIBLES',
  },
  {
    value: '903_PAVIMENTOS PLÁSTICOS',
    label: '903_PAVIMENTOS PLÁSTICOS',
  },
  {
    value: '904_PAVIMENTOS TEXTILES',
    label: '904_PAVIMENTOS TEXTILES',
  },
  {
    value: '905_PAVIMENTOS LIGEROS COMPUESTOS',
    label: '905_PAVIMENTOS LIGEROS COMPUESTOS',
  },
  {
    value: '906_PAVIMENTOS DE TERRAZO',
    label: '906_PAVIMENTOS DE TERRAZO',
  },
  {
    value: '907_PAVIMENTOS DE MADERA',
    label: '907_PAVIMENTOS DE MADERA',
  },
  {
    value: '1001_REVESTIMIENTOS CON PIEZAS CERÁMICAS',
    label: '1001_REVESTIMIENTOS CON PIEZAS CERÁMICAS',
  },
  {
    value: '1002_REVESTIMIENTOS DE PIEDRA NATURAL Y ARTIFICIAL',
    label: '1002_REVESTIMIENTOS DE PIEDRA NATURAL Y ARTIFICIAL',
  },
  {
    value: '1003_APLACADOS',
    label: '1003_APLACADOS',
  },
  {
    value: '1004_REVOCOS Y ENLUCIDOS',
    label: '1004_REVOCOS Y ENLUCIDOS',
  },
  {
    value: '1005_REVESTIMIENTOS DE FIBRAS Y PRODUCTOS TEXTILES',
    label: '1005_REVESTIMIENTOS DE FIBRAS Y PRODUCTOS TEXTILES',
  },
  {
    value: '1006_REVESTIMIENTOS DE PLANCHAS',
    label: '1006_REVESTIMIENTOS DE PLANCHAS',
  },
  {
    value: '1007_REVESTIMIENTOS DE MADERAS',
    label: '1007_REVESTIMIENTOS DE MADERAS',
  },
  {
    value: '1008_TECHOS SUSPENDIDOS',
    label: '1008_TECHOS SUSPENDIDOS',
  },
  {
    value: '1101_CIMENTACIONES Y ESTRUCTURAS DE MADERA',
    label: '1101_CIMENTACIONES Y ESTRUCTURAS DE MADERA',
  },
  {
    value: '1102_TABIQUERÍA DE MADERA',
    label: '1102_TABIQUERÍA DE MADERA',
  },
  {
    value: '1103_ENTARIMADOS DE MADERA',
    label: '1103_ENTARIMADOS DE MADERA',
  },
  {
    value: '1201_CARPINTERÍA EXTERIOR',
    label: '1201_CARPINTERÍA EXTERIOR',
  },
  {
    value: '1202_CARPINTERÍA INTERIOR',
    label: '1202_CARPINTERÍA INTERIOR',
  },
  {
    value: '1203_PUERTAS ESPECIALES',
    label: '1203_PUERTAS ESPECIALES',
  },
  { value: '1204_CERRAJERÍA', label: '1204_CERRAJERÍA' },
  { value: '1205_MAMPARAS', label: '1205_MAMPARAS' },
  { value: '1206_PERSIANAS', label: '1206_PERSIANAS' },
  { value: '1207_VIDRIOS', label: '1207_VIDRIOS' },
  {
    value: '1301_PINTURAS Y BARNICES',
    label: '1301_PINTURAS Y BARNICES',
  },
  {
    value: '1302_SEÑALIZACIÓN, BALIZAMIENTO Y BARRERAS DOBLE ONDA',
    label: '1302_SEÑALIZACIÓN, BALIZAMIENTO Y BARRERAS DOBLE ONDA',
  },
  {
    value: '1303_BARRERAS PREFABRICADAS CONTRA RUIDO O VIENTO',
    label: '1303_BARRERAS PREFABRICADAS CONTRA RUIDO O VIENTO',
  },
  {
    value: '1304_DEFENSAS Y ELEMENTOS DE AMARRE',
    label: '1304_DEFENSAS Y ELEMENTOS DE AMARRE',
  },
  {
    value: '1305_CERCADOS Y VALLAS',
    label: '1305_CERCADOS Y VALLAS',
  },
  {
    value: '1306_PLANTACIONES Y SIEMBRAS',
    label: '1306_PLANTACIONES Y SIEMBRAS',
  },
  {
    value: '1401_FONTANERÍA Y AGUA CALIENTE SANITARIA',
    label: '1401_FONTANERÍA Y AGUA CALIENTE SANITARIA',
  },
  {
    value: '1402_INSTALACIONES DE MOBILIARIO Y EQUIPAMIENTO URBANO',
    label: '1402_INSTALACIONES DE MOBILIARIO Y EQUIPAMIENTO URBANO',
  },
  {
    value: '1403_INSTALACIOINES DE MOBILIARIO DE EDIFICIO',
    label: '1403_INSTALACIOINES DE MOBILIARIO DE EDIFICIO',
  },
  {
    value: '1404_INSTALACIONES AUDIOVISUALES Y DE COMUNICACIONES',
    label: '1404_INSTALACIONES AUDIOVISUALES Y DE COMUNICACIONES',
  },
  {
    value: '1405_INSTALACIONES DE CLIMATIZACIÓN Y VENTILACIÓN',
    label: '1405_INSTALACIONES DE CLIMATIZACIÓN Y VENTILACIÓN',
  },
  {
    value: '1406_INSTALACIONES DE DETECCIÓN, PROTECCIÓN Y CONTROL',
    label: '1406_INSTALACIONES DE DETECCIÓN, PROTECCIÓN Y CONTROL',
  },
  {
    value: '1407_INSTALACIONES DEPORTIVAS',
    label: '1407_INSTALACIONES DEPORTIVAS',
  },
  {
    value: '1408_INSTALACIONES ELÉCTRICAS E ILUMINACIÓN',
    label: '1408_INSTALACIONES ELÉCTRICAS E ILUMINACIÓN',
  },
  {
    value: '1409_INSTALACIONES ESPECIALES',
    label: '1409_INSTALACIONES ESPECIALES',
  },
  {
    value: '1410_INSTALACIONES INDUSTRIALES',
    label: '1410_INSTALACIONES INDUSTRIALES',
  },
  {
    value: '1411_INSTALACIONES PARA COMBUSTIBLES LÍQUIDOS Y GASES',
    label: '1411_INSTALACIONES PARA COMBUSTIBLES LÍQUIDOS Y GASES',
  },
  {
    value: '1412_INSTALACIONES PARA DEPURACIÓN, TRATAMIENTO Y DESALACIÓN DE AGUAS',
    label: '1412_INSTALACIONES PARA DEPURACIÓN, TRATAMIENTO Y DESALACIÓN DE AGUAS',
  },
  {
    value: '1413_INSTALACIONES EN PRESAS Y CANALES',
    label: '1413_INSTALACIONES EN PRESAS Y CANALES',
  },
  {
    value: '1414_INSTALACIONES DE AUSCULTACIÓN',
    label: '1414_INSTALACIONES DE AUSCULTACIÓN',
  },
  {
    value: '1415_INSTALACIONES DE RIEGO',
    label: '1415_INSTALACIONES DE RIEGO',
  },
  {
    value: '1416_INSTALACIONES DE BOMBEO',
    label: '1416_INSTALACIONES DE BOMBEO',
  },
  {
    value: '1417_INSTALACIONES DE TRANSPORTE POR CABLE',
    label: '1417_INSTALACIONES DE TRANSPORTE POR CABLE',
  },
  {
    value: '1418_APARATOS ELEVADORES',
    label: '1418_APARATOS ELEVADORES',
  },
  {
    value: '1419_ESCALERAS Y PASILLOS MECÁNICOS',
    label: '1419_ESCALERAS Y PASILLOS MECÁNICOS',
  },
  {
    value: '1420_PASARELAS Y PUENTES TELESCÓPICOS',
    label: '1420_PASARELAS Y PUENTES TELESCÓPICOS',
  },
  {
    value: '1421_INSTALACIONES DE TRANSPORTE NEUMÁTICO',
    label: '1421_INSTALACIONES DE TRANSPORTE NEUMÁTICO',
  },
  {
    value: '1430_OTRAS INSTALACIONES',
    label: '1430_OTRAS INSTALACIONES',
  },
  { value: 'ZZZZ_OTROS', label: 'ZZZZ Otros' },
  { value: '101_SURVEYING', label: '101_SURVEYING' },
];

export const NON_CONFORMITY_TYPE_OPTIONS = [
  {
    value: '0_Uso incorrecto de documentos',
    label: '0_Uso incorrecto de documentos',
  },
  {
    value: '15_Errores de proyecto no detectados en su revisión',
    label: '15_Errores de proyecto no detectados en su revisión',
  },
  {
    value: '20_Falta de documentación acreditativa de la calidad',
    label: '20_Falta de documentación acreditativa de la calidad',
  },
  {
    value: '30_Recepción de Materiales: Material defectuoso o en mal estado, con defectos, o es diferente al solicitado (excepto hormigón in situ)',
    label: '30_Recepción de Materiales: Material defectuoso o en mal estado, con defectos, o es diferente al solicitado (excepto hormigón in situ)',
  },
  {
    value: '31_Descarga, manipulación y acopio en obra: Materiales que han sufrido daños en uno de estos procesos.',
    label: '31_Descarga, manipulación y acopio en obra: Materiales que han sufrido daños en uno de estos procesos.',
  },
  {
    value: '32_No conformidades en el suministro de hormigón que se pueden detectar en el momento de la recepción',
    label: '32_No conformidades en el suministro de hormigón que se pueden detectar en el momento de la recepción',
  },
  {
    value: '33_Errores en la planificación de los ensayos',
    label: '33_Errores en la planificación de los ensayos',
  },
  {
    value: '34_Resultados de ensayos de materiales no satisfactorios (incluyendo bajas resistencias del hormigón )',
    label: '34_Resultados de ensayos de materiales no satisfactorios (incluyendo bajas resistencias del hormigón )',
  },
  {
    value: '35_Resultados no satisfactorios de pruebas de instalaciones o equipos',
    label: '35_Resultados no satisfactorios de pruebas de instalaciones o equipos',
  },
  {
    value: '40_Errores replanteo (topográficos o métricos)',
    label: '40_Errores replanteo (topográficos o métricos)',
  },
  {
    value: '50_Defectos de geometría, planeidad, horizontalidad, verticalidad',
    label: '50_Defectos de geometría, planeidad, horizontalidad, verticalidad',
  },
  {
    value: '51_Defectos de humedad o compactación de terrenos, suelos o rellenos',
    label: '51_Defectos de humedad o compactación de terrenos, suelos o rellenos',
  },
  {
    value: '52_Defectos de colocación encofrados',
    label: '52_Defectos de colocación encofrados',
  },
  {
    value: '53_Defectos de armaduras pasivas (elaboración, montaje y colocación)',
    label: '53_Defectos de armaduras pasivas (elaboración, montaje y colocación)',
  },
  {
    value: '54_Defectos de armaduras activas. Tesado',
    label: '54_Defectos de armaduras activas. Tesado',
  },
  {
    value: '55_Defectos de hormigonado',
    label: '55_Defectos de hormigonado',
  },
  {
    value: '56_Defectos de curado, desencofrado, descimbrado',
    label: '56_Defectos de curado, desencofrado, descimbrado',
  },
  {
    value: '57_Defectos de colocación de prefabricados hormigón',
    label: '57_Defectos de colocación de prefabricados hormigón',
  },
  {
    value: '58_Defectos de montaje de instalaciones o de sus componentes',
    label: '58_Defectos de montaje de instalaciones o de sus componentes',
  },
  {
    value: '59_Defectos de soldaduras y uniones de estructuras metélicas',
    label: '59_Defectos de soldaduras y uniones de estructuras metélicas',
  },
  {
    value: '60_Defectos de estanqueidad (impermeabilización)',
    label: '60_Defectos de estanqueidad (impermeabilización)',
  },
  {
    value: '61_Defectos de acabados',
    label: '61_Defectos de acabados',
  },
  {
    value: '62_Defectos de ejecución de juntas',
    label: '62_Defectos de ejecución de juntas',
  },
  {
    value: '63_Defectos de unión al soporte (baldosas, azulejos etc?)',
    label: '63_Defectos de unión al soporte (baldosas, azulejos etc?)',
  },
  {
    value: '64_Resultados no satisfactorios de pruebas finales de procesos',
    label: '64_Resultados no satisfactorios de pruebas finales de procesos',
  },
  {
    value: '65_Protección inadecuada de partes terminadas',
    label: '65_Protección inadecuada de partes terminadas',
  },
  {
    value: '66_Defectos de realización no tipificados',
    label: '66_Defectos de realización no tipificados',
  },
  {
    value: '70_Emisiones atmosféricas incontroladas o superiores a límites',
    label: '70_Emisiones atmosféricas incontroladas o superiores a límites',
  },
  {
    value: '71_Ruidos y vibraciones',
    label: '71_Ruidos y vibraciones',
  },
  {
    value: '72_Vertidos incontrolados a cauces de agua o al mar',
    label: '72_Vertidos incontrolados a cauces de agua o al mar',
  },
  {
    value: '73_Gestión inadecuada de residuos peligrosos',
    label: '73_Gestión inadecuada de residuos peligrosos',
  },
  {
    value: '74_Gestión inadecuada de otros residuos (tierras, RCD, RSU...)',
    label: '74_Gestión inadecuada de otros residuos (tierras, RCD, RSU...)',
  },
  {
    value: '75_Contaminación de suelo',
    label: '75_Contaminación de suelo',
  },
  {
    value: '76_Empleo incontrolado o inadecuado de recursos naturales y materias primas',
    label: '76_Empleo incontrolado o inadecuado de recursos naturales y materias primas',
  },
  {
    value: '77_Afección al patrimonio cultural y arqueológico',
    label: '77_Afección al patrimonio cultural y arqueológico',
  },
  {
    value: '78_Afección a servicios existentes',
    label: '78_Afección a servicios existentes',
  },
  {
    value: '79_Afección al medio natural (fauna, flora, captaciones,?)',
    label: '79_Afección al medio natural (fauna, flora, captaciones,?)',
  },
  {
    value: '80_Otras no conformidades medioambientales',
    label: '80_Otras no conformidades medioambientales',
  },
  {
    value: '100_Gestión y documentación',
    label: '100_Gestión y documentación',
  },
  {
    value: '101_Señalización/Cerramiento/Iluminación/Organización general obra',
    label: '101_Señalización/Cerramiento/Iluminación/Organización general obra',
  },
  {
    value: '102_Instalaciones de higiene y bienestar / Primeros auxilios',
    label: '102_Instalaciones de higiene y bienestar / Primeros auxilios',
  },
  {
    value: '103_Circulación y accesos a tajos',
    label: '103_Circulación y accesos a tajos',
  },
  {
    value: '104_Protecciones personales',
    label: '104_Protecciones personales',
  },
  {
    value: '105_Prevención técnica y protecciones colectivas',
    label: '105_Prevención técnica y protecciones colectivas',
  },
  {
    value: '106_Medios auxiliares',
    label: '106_Medios auxiliares',
  },
  {
    value: '107_Maquinaria y equipos de trabajo',
    label: '107_Maquinaria y equipos de trabajo',
  },
  {
    value: '108_Instalaciones provisionales de obra',
    label: '108_Instalaciones provisionales de obra',
  },
  { value: 'ZZZ_otros', label: 'ZZZ_otros' },
  { value: '00_Design', label: '00_Design' },
  {
    value: '10_Incorrect use of documents',
    label: '10_Incorrect use of documents',
  },
  {
    value: '30_Material receiving: Defect or in bad condition material, or different from material ordered (except "in situ" concrete)',
    label: '30_Material receiving: Defect or in bad condition material, or different from material ordered (except "in situ" concrete)',
  },
  {
    value: '32_Concrete supply nonconformities that are detected upon receiving',
    label: '32_Concrete supply nonconformities that are detected upon receiving',
  },
  {
    value: '33_Errors in test planning',
    label: '33_Errors in test planning',
  },
  {
    value: '34_Non satisfactory material testing results (including low concrete strengths)',
    label: '34_Non satisfactory material testing results (including low concrete strengths)',
  },
  {
    value: '36_Others materials and equipment nonconformities',
    label: '36_Others materials and equipment nonconformities',
  },
  {
    value: '40_Surveying errors (topographical o metrical)',
    label: '40_Surveying errors (topographical o metrical)',
  },
  {
    value: '50_Defects in geometry, flatness, horizontality, verticality',
    label: '50_Defects in geometry, flatness, horizontality, verticality',
  },
  {
    value: '52_Defective placement of formwork',
    label: '52_Defective placement of formwork',
  },
  {
    value: '53_Defects in passive reinforcement (fabrication, assembly and placement)',
    label: '53_Defects in passive reinforcement (fabrication, assembly and placement)',
  },
  {
    value: '55_Defects from concreting',
    label: '55_Defects from concreting',
  },
  {
    value: '58_Defects in assembly of systems and components',
    label: '58_Defects in assembly of systems and components',
  },
  {
    value: '60_Watertight defects (waterproofing)',
    label: '60_Watertight defects (waterproofing)',
  },
  {
    value: '61_Finishing work defects',
    label: '61_Finishing work defects',
  },
  {
    value: '67_Other non conformities on execution of work processes',
    label: '67_Other non conformities on execution of work processes',
  },
  {
    value: '68_breach of procedure or instruction',
    label: '68_breach of procedure or instruction',
  },
  {
    value: '69_Overpass forecast vibrations speed limit near quick clay areas',
    label: '69_Overpass forecast vibrations speed limit near quick clay areas',
  },
  {
    value: '79_Effects on environment (fauna, flora, water uptake...)',
    label: '79_Effects on environment (fauna, flora, water uptake...)',
  },
  {
    value: '200_Overpass forecast vibrations speed limit over 50%',
    label: '200_Overpass forecast vibrations speed limit over 50%',
  },
  {
    value: '201_Overpass forecast vibrations speed limit under 50%',
    label: '201_Overpass forecast vibrations speed limit under 50%',
  },
  {
    value: '202_Overpass forecast vibrations speed limit in tunnels under 50%',
    label: '202_Overpass forecast vibrations speed limit in tunnels under 50%',
  },
  {
    value: '203_Overpass forecast vibrations speed limit in tunnels over 50%',
    label: '203_Overpass forecast vibrations speed limit in tunnels over 50%',
  },
  {
    value: 'D20_Lack of quality related supporting documents',
    label: 'D20_Lack of quality related supporting documents',
  },
  {
    value: 'D21_Other nonconformities on documentation',
    label: 'D21_Other nonconformities on documentation',
  },
];
